export const MRW_COURIER_ID = 16;

export type DataLoadUploadId = 'accounting_shipments' | 'courier_weight_files';

export interface DataLoadUploadDefinition {
  id: DataLoadUploadId;
  titleKey: string;
  descriptionKey: string;
}

export const DATA_LOAD_UPLOADS: DataLoadUploadDefinition[] = [
  {
    id: 'accounting_shipments',
    titleKey: 'uploads.accounting_shipments.title',
    descriptionKey: 'uploads.accounting_shipments.description',
  },
  {
    id: 'courier_weight_files',
    titleKey: 'uploads.courier_weight_files.title',
    descriptionKey: 'uploads.courier_weight_files.description',
  },
];

export interface UploadCourierWeightFileRequest {
  courier_id: number;
  file: File;
}

export interface CourierWeightUploadStats {
  filename: string;
  total_rows: number;
  skipped_invalid_status: number;
  eligible_rows: number;
  weights_saved: number;
  skipped_invalid_order_id: number;
  skipped_invalid_weight: number;
  skipped_order_not_found: number;
  skipped_order_not_found_refs: string[];
}

export interface UploadCourierWeightFileResponse {
  message: string;
  data: CourierWeightUploadStats;
}
